export const data = {
    experience: [
        {
            title: "Consultant",
            subtitle: "Miami,FL",
            description: "User Experience,Visual Design"
        },
        {
            title: "Junior Consultant",
            subtitle: "London,UK",
            description: "Visual Design"
        },
        {
            title: "internship",
            subtitle: "Delhi",
            description: "Web developement,Database,Backend developement"
        },
    ],
    education: [
        {
            title: "Secondary",
            subtitle: "St Xavier High School",
            description: "10th "
        },
        {
            title: " Higher Secondary",
            subtitle: "St Xavier High School",
            description: "12th Grade in Science "
        },
    ],
};